// The most code the sandbox runs (a large generated formatter included): larger code is refused, not run.
export const MAX_CODE_SIZE_BYTES = 512 * 1024;
//# sourceMappingURL=code-code-1.js.map